import React, { useEffect, useRef } from 'react';
import './UnsavedChangesDialog.css';

// LF-S4: confirmation shown when the user leaves a page with unsaved session
// changes. Save / Discard / Cancel.
// LF-S5: focus trap + ARIA for accessibility.
export default function UnsavedChangesDialog({ open, dirtyCount, onSave, onDiscard, onCancel }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const node = ref.current;
    if (!node) return undefined;
    const focusables = () => Array.from(node.querySelectorAll('button'));
    const first = focusables()[0];
    if (first) first.focus();
    const onKey = (e) => {
      if (e.key !== 'Tab') return;
      const items = focusables();
      if (items.length === 0) return;
      const firstEl = items[0];
      const lastEl = items[items.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) {
        e.preventDefault();
        lastEl.focus();
      } else if (!e.shiftKey && document.activeElement === lastEl) {
        e.preventDefault();
        firstEl.focus();
      }
    };
    node.addEventListener('keydown', onKey);
    return () => node.removeEventListener('keydown', onKey);
  }, [open]);

  if (!open) return null;
  return (
    <div
      className="unsaved-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="unsaved-dialog-title"
      data-testid="unsaved-dialog"
      ref={ref}
    >
      <div className="unsaved-dialog">
        <h3 id="unsaved-dialog-title">Unsaved changes</h3>
        <p>
          You have {dirtyCount} unsaved change{dirtyCount !== 1 ? 's' : ''}.
          What would you like to do?
        </p>
        <div className="unsaved-actions">
          <button className="btn btn-primary" onClick={onSave}>Save and leave</button>
          <button className="btn btn-danger" onClick={onDiscard}>Discard and leave</button>
          <button className="btn" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
